import type { FaireThemeEntity } from "../../entity_types/theme";

export const southwest_road_trip_vibes: FaireThemeEntity = {
  token: "southwest-road-trip-vibes",
  type: "theme",
  name: "Southwest Road Trip Vibes",
  description: "Capture the essence of a desert adventure with Arizona-inspired novelties and road-trip-ready snacks. A curated mix of comfort apparel and travel-friendly gifts for the wandering soul.",
  teaser: "The retailer frequently stocks 'bohemian winter hats,' 'elephant print pants,' and a wide variety of chips, suggesting a customer base that appreciates eclectic, travel-ready styles and novelty snacks.",
  detail: "This theme is supported by the recent search query for 'arizona' and 'dvd movies,' paired with the retailer's established high volume of searches and orders for various 'chips' and 'snacks.'",
  bgColor: "#D4D4FF",
  tileBgColor: "#6b3a5b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_zgqfzc97f3",
    "p_u747wku2ha",
    "p_q2mr75aw7m",
    "p_myb8s65nkg",
    "p_5qfpxpcp7m",
    "p_axv2b2unj4",
    "p_x8y4ccgbqk",
    "p_2nhhqvyf7e",
    "p_6rwqbht8gc",
    "p_2qnc9twv45",
    "p_3c8krf49h6",
    "p_dx6q8hmq3h",
    "p_695ydawfjn",
    "p_tsbrw9tdfc",
    "p_ykmex5bwyz",
    "p_49h9unzavy",
    "p_43dnn9rgm2",
    "p_qureps3m8n",
    "p_pcwbyysd4v",
    "p_hfs3m53mcg",
    "p_s47vzqyazd",
    "p_9u5nyftcfr",
    "p_vrum47fjdd",
    "p_u5bddnlw55",
    "p_2su4rcfyag",
    "p_9xptsrgv2f",
    "p_z338nz4y7f",
    "p_cttesmzftz",
    "p_6jz5vbcf3z",
    "p_hbqy59h22x",
    "p_fr26cfbpsa",
    "p_v2qz9x62gm",
    "p_6dgsnnr77p",
    "p_yfygegf83n",
    "p_3a58vnca4g",
    "p_dvha5vqz7g",
    "p_5nv9xwbyzy",
    "p_nh54rp6a79",
    "p_46ugzthp9q",
    "p_75ucmrbbqj",
    "p_y7zpstyrb7",
    "p_np4kqupzbd",
    "p_2y98aka769",
    "p_xp9u3sm9dx",
    "p_v7q3r5y8vn",
    "p_36eu2yanjt",
    "p_bbfaa8za8a",
    "p_pvb7a5sg8c",
    "p_hucyhj6qqs",
    "p_s9cymaks9h",
    "p_d6azr888ch",
    "p_pr79g4xq3u",
    "p_np3j84da9j",
    "p_55pprbav45",
    "p_h7rrd8z7s8",
    "p_bj82mwwfsr",
    "p_p73p6djwwh",
    "p_ne4aqt5ujh",
    "p_neduxzf5d2",
    "p_75up5hgf2h",
    "p_a3c8qcnw56",
    "p_95qcmfjjbw",
    "p_cdh4um42sj",
    "p_kaspsnemwu",
    "p_6shh56wmu9",
    "p_vc52crbh5m",
    "p_79c86ytjaz",
    "p_6e3p4fjpuv",
    "p_jsw72dh7nm",
    "p_dhpf3uzs9f",
    "p_yspxxv35ej",
    "p_b8udbd9mvz",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
